/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-02-10 14:24:24
 * @Description: 剖切相关
 * @LastEditors: Please set LastEditors
 */
import { Message } from 'element-ui'
let axisObjs = []
let clipObj = {}
/**
 * @description: 创建剖切盒子
 * @param {*}
 * @return {*}
 */
const createCilpBox = async (player, playerId) => {
  let modelInfo = {}
  const selectInfo = await PlayerUtils.call(player.Native.ModelTree.getSelectedItem)
  if (!_.isEmpty(selectInfo)) {
    player.Native.Camera.moveToItem(selectInfo.item, 2)
    modelInfo = await PlayerUtils.call(player.Native.ModelTree.calcItemAabb, selectInfo.item)
  } else {
    modelInfo = await PlayerUtils.call(player.Native.Model.getInfo, playerId)
  }
  player.Native.ClipBox.ClipBoxInitByAabb(clipObj, [modelInfo.aabb.min, modelInfo.aabb.max])
}
const createAxis = async (player, axisType) => {
  if (axisType === 1) {
    // 指定坐标轴位置
    player.Native.NodeEditor.setNode(clipObj)
    player.Native.NodeEditor.setEditType(1)
    player.Native.NodeEditor.setEditCoordinateSysType(2)
  }
  // 创建轴编辑对象
  if (axisType === 4) {
    for (let i = 0; i < 6; ++i) {
      // 创建轴对象  4.为单轴移动编辑轴
      axisObjs[i] = await PlayerUtils.call(player.Native.Axis.createEditAxis, axisType)
      const tmpPs = await PlayerUtils.call(player.Native.Axis.properties, axisObjs[i])
      // 轴的风格属性,0:箭头风格;1:圆锥风格
      tmpPs.style = 1
      const tmpTR = await PlayerUtils.call(player.Native.ClipBox.ClipBoxPanelTRMatrix, clipObj, i)
      const d = Matrix4.decompose(tmpTR)
      tmpPs.position = d.position
      tmpPs.dir = Matrix4.multiplyDir(d.rotation, [0, 0, 1])
      player.Native.Axis.setProperties(axisObjs[i], tmpPs)
    }
  }
}
const onEditting = async (param) => {
  let index = -1
  for (let i = 0; i < axisObjs.length; ++i) {
    if (param.sender == axisObjs[i]) index = i
  }
  if (index < 0 || index > 5) return
  if (!clipObj) return

  // 移动面
  player.Native.ClipBox.ClipBoxMovePanel(clipObj, param.relativeOffset, index)

  // 编辑轴跟随移动
  for (let i = 0; i < axisObjs.length; ++i) {
    const tmpPs = await player.Native.Axis.properties(axisObjs[i])
    tmpPs.style = 1
    const tmpTR = await player.Native.ClipBox.ClipBoxPanelTRMatrix(clipObj, i)
    const d = Matrix4.decompose(tmpTR)
    tmpPs.position = d.position
    tmpPs.dir = Matrix4.multiplyDir(d.rotation, [0, 0, 1])
    player.Native.Axis.setProperties(axisObjs[i], tmpPs)
  }
}
/**
 * @description:
 * @param {player,setIsInside,setPartCilp,clipType, axisType}
 *                是否启用内剖切，是否启用局部剖切,剖切方式,轴样式
 * @return {*}
 */
async function setCilp(player, playerId, setIsInside, setPartCilp, clipType, axisType) {
  // 获取当前点选的对象
  const selectInfo = await PlayerUtils.call(player.Native.ModelTree.getSelectedItem)
  // 是否启用局部剖切
  if (setPartCilp) {
    if (_.isEmpty(selectInfo)) {
      Message.warning('请先点选模型！')
      return
    }
    player.Native.ClipBox.setLocalEnabled(selectInfo.item)
  } else {
    player.Native.ClipBox.setLocalDisabled()
  }
  // 启用剖切
  player.Native.ClipBox.setEnabled(true)
  // 是否启用内剖切
  player.Native.ClipBox.setIsInside(setIsInside)
  // 创建剖切对象

  switch (clipType) {
    case 'box':
      // 盒子剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipBox)
      // 创建剖切盒子
      await createCilpBox(player, playerId)
      break
    case 'singlePanel':
      // 单面剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipPanel)
      break
    case 'doublePanel':
      // 双面剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipTwoPanel)
      break
    case 'ThreePanel':
      // 三面剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipThreePanel)
      const currentParam = await PlayerUtils.call(player.Native.Camera.currentParam)
      const position = await PlayerUtils.call(player.Native.Camera.getAnchorPos)
      player.Native.ClipBox.clipThreePanelInitByPoints(clipObj, position, currentParam.eye, [
        2,
        2,
        2,
      ])
      break
    default:
      break
  }
  // 创建编辑轴

  await createAxis(player, axisType)
  player.Native.Axis.EventAxisEditting.connect(onEditting)
  return {
    clipObj,
    axisObjs,
  }
}
/**
 * @description: 取消剖切
 * @param {*}
 * @return {*}
 */
function cancelClip(player) {
  player.Native.ClipBox.setEnabled(false)
  // 取消激活剖切对象
  player.Native.ClipBox.inactiveClipObject()
  player.Native.Axis.destroyAllEditAxis()
  player.Native.Axis.EventAxisEditting.disconnect(onEditting)
  player.Native.NodeEditor.setNode(0)
}

export { setCilp as cilpSetting, cancelClip }
